import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  deleteRoomScan as apiDelete,
  listRoomScans,
  patchRoomScan as apiPatch,
} from '../../lib/api/roomScans.js'

const ROOM_SCANS_KEY = ['assets', 'room-scans']

export function useRoomScans() {
  return useQuery({
    queryKey: ROOM_SCANS_KEY,
    queryFn: () => listRoomScans(),
    staleTime: 30 * 1000,
  })
}

export function usePatchRoomScan() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, patch }) => apiPatch(id, patch),
    onSuccess: () => qc.invalidateQueries({ queryKey: ROOM_SCANS_KEY }),
  })
}

export function useDeleteRoomScan() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id }) => apiDelete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ROOM_SCANS_KEY }),
  })
}
